import React from 'react';
// import App from '@/pages/App';
// @ts-ignore
import RouterGuard from '@/components/RouterGuard';
import type { Route } from '@/types/common';
import guildRoutes from './guild';

// const Demo = React.lazy(() => import('@/pages/Guild/demo'))
const Demo = React.lazy(() => import('@/pages/demo'));
// 举报反馈
const Report = React.lazy(() => import('@/pages/Report'));
// 财富魅力等级
const Level = React.lazy(() => import('@/pages/Level'));
// 代理：充值转账
const Agent = React.lazy(() => import('@/pages/Agent'));
// 支付回调页面
const PayResult = React.lazy(() => import('@/pages/Pay/Result'));
// 官网
const Official = React.lazy(() => import('@/pages/Official/Home'));
const Recharge = React.lazy(() => import('@/pages/Official/Recharge'));

// 代理充值转账记录
const AgentTransferRecord = React.lazy(
  () => import('@/pages/Agent/TransferRecord'),
);

export interface RoutesMap {
  [key: string]: string;
}

const routes: Route[] = [
  // 官网
  {
    path: '/',
    name: 'App',
    title: 'Soulike',
    meta: {
      noAuthLogin: 0, // 不需要登录
    },
    element: <Official />,
  },
  // 官网充值
  {
    path: '/recharge',
    name: 'Recharge',
    meta: {
      noAuthLogin: 0, // 不需要登录
    },
    element: <Recharge />,
  },
  ...guildRoutes,
  {
    path: '/demo',
    name: 'Demo',
    title: 'Demo',
    meta: {
      noAuthLogin: 0, // 不需要登录
    },
    element: <Demo />,
  },
  {
    path: '/report',
    name: 'Report',
    title: '举报和反馈',
    element: <Report />,
  },
  {
    path: '/level',
    name: 'Level',
    title: '财富魅力等级',
    element: <Level />,
  },
  {
    path: '/agent',
    name: 'Agent',
    element: <Agent />,
  },
  {
    path: '/agent/transfer-record',
    name: 'AgentTransferRecord',
    element: <AgentTransferRecord />,
  },
  {
    path: '/pay-result',
    name: 'PayResult',
    meta: {
      noAuthLogin: 0, // 不需要登录
    },
    element: <PayResult />,
  },
];

// 用来做路由导航时路径名和路径的映射
export const routesMap: RoutesMap = routes.reduce(
  (acc: RoutesMap, cur: Route) => {
    const { path, name } = cur;
    acc[name] = path;
    return acc;
  },
  {},
);

export default routes;
